import { ScreenTracking, SCREEN_ASSET_ID } from '../../../domain/amplitude'
import { CreditApplicationDetails } from '../../../domain/creditApplication'
import { ALMOST_SCREEN } from '../AlmostThere/types'

export enum CreditApplicationErrors {
  HTTP,
  NOT_APPROVED,
  GENERIC,
  REVIEW
}

export type CreditApplicationError = {
  errorMessage: string
  type: CreditApplicationErrors
}

export type ApplicationSubmittedProps = {
  applicationId: string
  handleReady: (creditApplication: CreditApplicationDetails) => void
  handleError: (error: CreditApplicationError) => void
}

export type ApplicationErrorProps = {
  error: CreditApplicationError
}

export type ApplicationWaitingProps = {
  subtitleText?: string
}

export const PROCESSING_SCREEN = 'processingPage'

export const OffToRacesScreen: ScreenTracking = {
  asset_id: SCREEN_ASSET_ID,
  heading: 'Off to the Races!',
  screen: PROCESSING_SCREEN,
  from_screen: ALMOST_SCREEN
}

export const OffToRacesScreenCreditOffer = {
  ...OffToRacesScreen,
  from_screen: 'preApproved'
}

export const NotApprovedScreen: ScreenTracking = {
  asset_id: SCREEN_ASSET_ID,
  heading: 'Your Application is not approved at this time',
  screen: 'notApproved',
  from_screen: PROCESSING_SCREEN
}

export const AdditionalReviewScreen: ScreenTracking = {
  asset_id: SCREEN_ASSET_ID,
  heading: "You're almost done!",
  screen: 'offerPending',
  from_screen: PROCESSING_SCREEN
}

export const OopsErrorScreen: ScreenTracking = {
  asset_id: SCREEN_ASSET_ID,
  heading: 'Oops!',
  screen: 'offerOops',
  from_screen: PROCESSING_SCREEN
}
